import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "gfu-creators-line",
  "data-qa": "creator-names"
}
const _hoisted_2 = {
  key: 0,
  class: "gfu-creators-line__prefix"
}
const _hoisted_3 = ["title"]
const _hoisted_4 = ["href"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 2,
  "data-qa": "other-creators"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (!$props.hidePrefix)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.Resources.Common.ByText) + " ", 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("span", {
      class: "gfu-creators-line__name",
      title: $props.creator.name,
      "data-qa": "main-creator-name"
    }, [
      ($props.showAsLinks && $props.creator.url)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "gfu-link",
            href: $props.creator.url
          }, _toDisplayString($props.creator.name), 9 /* TEXT, PROPS */, _hoisted_4))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString($props.creator.name), 1 /* TEXT */)
          ], 64 /* STABLE_FRAGMENT */))
    ], 8 /* PROPS */, _hoisted_3),
    ($options.hasOneCoCreator)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "gfu-creators-line__separator" }, " & ", -1 /* CACHED */)),
          _createElementVNode("span", {
            class: "gfu-creators-line__name",
            title: $options.firstCoCreator.name,
            "data-qa": "co-creator-name"
          }, [
            ($props.showAsLinks && $options.firstCoCreator.url)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "gfu-link",
                  href: $options.firstCoCreator.url
                }, _toDisplayString($options.firstCoCreator.name), 9 /* TEXT, PROPS */, _hoisted_6))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString($options.firstCoCreator.name), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
          ], 8 /* PROPS */, _hoisted_5)
        ], 64 /* STABLE_FRAGMENT */))
      : ($options.hasMultipleCoCreators)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, " +" + _toDisplayString($props.coCreators.length) + " " + _toDisplayString(_ctx.Resources.Common.MoreText), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
  ]))
}